import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

export const NetDepositLimitConfigurationPanelWrapper = styled('div', { label: 'NetDepositLimitConfigurationPanelWrapper' })`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    border: 1px solid ${mainColors.grays.gray200};
    border-radius: 8px;
    background-color: ${mainColors.grays.gray100};
`;

export const NetDepositLimitConfigurationPanelTitleRow = styled('div', { label: 'NetDepositLimitConfigurationPanelTitleRow' })`
    display: flex;
    align-items: center;
    gap: 6px;
`;

export const NetDepositLimitConfigurationPanelTitle = styled('h4', { label: 'NetDepositLimitConfigurationPanelTitle' })`
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.38;
    color: ${mainColors.grays.gray500};
`;

export const NetDepositLimitConfigurationPanelDescription = styled('p', { label: 'NetDepositLimitConfigurationPanelDescription' })`
    margin: 8px 0 0;
    font-size: 13px;
    line-height: 1.38;
    color: ${mainColors.grays.gray400};
`;

export const NetDepositLimitConfigurationPanelGrid = styled('div', { label: 'NetDepositLimitConfigurationPanelGrid' })<{ columns: number }>`
    display: grid;
    grid-template-columns: repeat(${({ columns }): number => columns}, minmax(0, 1fr));
    gap: 12px 16px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

export const NetDepositLimitConfigurationPanelField = styled('div', { label: 'NetDepositLimitConfigurationPanelField' })`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
`;

export const NetDepositLimitConfigurationPanelDropdownField = styled(NetDepositLimitConfigurationPanelField, { label: 'NetDepositLimitConfigurationPanelDropdownField' })`
    > div {
        margin-bottom: 0;
    }

    [data-test='input-error'] {
        margin-top: 4px;
    }
`;

export const NetDepositLimitConfigurationPanelFieldLabel = styled('span', { label: 'NetDepositLimitConfigurationPanelFieldLabel' })`
    font-size: 12px;
    font-weight: 500;
    line-height: 1.33;
    color: ${mainColors.grays.gray400};
`;

export const NetDepositLimitConfigurationPanelHelperText = styled('p', { label: 'NetDepositLimitConfigurationPanelHelperText' })`
    margin: 0;
    font-size: 12px;
    line-height: 1.33;
    color: ${mainColors.grays.gray400};
`;

export const NetDepositLimitConfigurationPanelLifetimeValue = styled('span', { label: 'NetDepositLimitConfigurationPanelLifetimeValue' })`
    display: flex;
    align-items: center;
    min-height: 48px;
    font-size: 14px;
    line-height: 1.43;
    color: ${mainColors.grays.gray500};
`;

export const NetDepositLimitConfigurationPanelToggles = styled('div', { label: 'NetDepositLimitConfigurationPanelToggles' })`
    display: flex;
    flex-wrap: wrap;
    gap: 16px 24px;
    padding-top: 4px;
    border-top: 1px solid ${mainColors.grays.gray200};
`;

export const NetDepositLimitConfigurationPanelToggle = styled('div', { label: 'NetDepositLimitConfigurationPanelToggle' })`
    display: flex;
    align-items: center;
`;
